module.exports = __webpack_public_path__ + "img/1.14_Russian_road_sign.15217f58.svg";